/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ClientActionResponse, DeleteClientApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    deleteClient: build.mutation<ClientActionResponse, DeleteClientApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/v1/clients/${queryArg.clientId}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as deleteClientApi };
export const { useDeleteClientMutation } = injectedRtkApi;
